
import React, { memo } from 'react';
import styled, { CSSObject } from 'styled-components';
import { WidgetHeaderTextType } from '../types';
import { ArrowIcon } from '../utilities/arrowIcon';

interface WidgetHeaderProps {
    showArrowIcon?: boolean;
    headerText?: WidgetHeaderTextType;
    iconStyle?: CSSObject;
}

export const WidgetHeader = memo(({
    showArrowIcon = true,
    headerText,
    iconStyle
}: WidgetHeaderProps) => {

    return (
        <Container>
            <HeaderText>
                { headerText?.widgetTitle }
                { headerText?.subWidgetTitle && <SubHeaderText> {headerText?.subWidgetTitle} </SubHeaderText>}
            </HeaderText>
            <IconContainer iconCustomStyles={iconStyle}>
                <ArrowContainer>
                    {showArrowIcon && <ArrowIcon />} 
                </ArrowContainer>
            </IconContainer>
        </Container>
    );
});

WidgetHeader.displayName = 'WidgetHeader';

const SubHeaderText = styled.div`
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
text-transform: none;
flex-grow: 1;
font-weight: 400;
margin: 0 8px;
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    padding: 5px 10px;
    background-color: #ffffff;
    border-bottom: 1px solid #eee;
    color: #555;
    min-height: 26px;
    vertical-align: middle;
    font-size: 16px;
    font-weight: 600;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
`;

const HeaderText = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    min-height: 26px;
    text-transform: uppercase;
    width: calc(100% - 6px);
    padding-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

interface IconContainerProps {
    iconCustomStyles?: CSSObject;
}
const IconContainer = styled.span<IconContainerProps>`
    position: relative;
    width: 6px;
    height: 26px;
    margin-left: 8px;
    ${({ iconCustomStyles }) =>  iconCustomStyles && iconCustomStyles};
`;

const ArrowContainer = styled.svg`
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -3px;
    margin-left: -5px;
    fill: #666;
    stroke-width: 1px;
    stroke: #666;
    width: 10px;
    height: 6px;
`;